import React from 'react';
// import { Link } from 'react-router-dom';

const Hero: React.FC = () => {
  return (
    <section id="home" className="hero">
      <video
        className="hero-video"
        autoPlay
        // loop
        muted
        playsInline
        aria-label="Healthcare equipment installation video showcasing JVP's work"
      >
        <source src="/images/hero/hero-video.webm" type="video/webm" />
        <source src="/images/hero/hero-video.mp4" type="video/mp4" />
      </video>
      <div className="hero-overlay" />
      {/* <div className="hero-content"> */}
      <div className="hero-content hero-content-bottom">
          <h1>Healthcare Equipment Installation & Support</h1>
        <p>Whatever your facility needs — a single workstation, a full department build-out, or a coast-to-coast rollout — <br />we handle every mount, every cable, and everything in between.</p>
        {/* <Link to="/contact" className="cta-button">Request a Quote</Link> */}
      </div>
    </section>
  );
};

export default Hero;
